export const ENTRY_CAP = 'entryCap';
export const FEE = 'cost';
export const PAYOUT = 'payout';
export const POINTS = 'score';
export const PRIZE = 'prizePoolValue';
export const RANK = 'rank';
export const WINNINGS = 'winnings';
